import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgWatchlist(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.86254 9.35534L5.23758 11.1697L4.32989 14.1071C3.98495 15.2233 5.27644 16.1242 6.20487 15.4149L8.49975 13.6618L10.7946 15.4149C11.7231 16.1242 13.0146 15.2233 12.6696 14.1071L11.7619 11.1697L14.137 9.35534C15.0491 8.65853 14.5563 7.20175 13.4085 7.20175H10.5358L9.64626 4.32325C9.29781 3.19563 7.7017 3.19564 7.35325 4.32325L6.46374 7.20175H3.59101C2.44318 7.20175 1.9504 8.65853 2.86254 9.35534ZM13.4998 4C13.2236 4 12.9998 4.22386 12.9998 4.5C12.9998 4.77614 13.2236 5 13.4998 5H19.4998C19.7759 5 19.9998 4.77614 19.9998 4.5C19.9998 4.22386 19.7759 4 19.4998 4H13.4998ZM16.4998 9C16.2236 9 15.9998 9.22386 15.9998 9.5C15.9998 9.77614 16.2236 10 16.4998 10H19.4998C19.7759 10 19.9998 9.77614 19.9998 9.5C19.9998 9.22386 19.7759 9 19.4998 9H16.4998ZM14.9998 14.5C14.9998 14.2239 15.2236 14 15.4998 14H19.4998C19.7759 14 19.9998 14.2239 19.9998 14.5C19.9998 14.7761 19.7759 15 19.4998 15H15.4998C15.2236 15 14.9998 14.7761 14.9998 14.5ZM4.49976 19C4.22361 19 3.99976 19.2239 3.99976 19.5C3.99976 19.7761 4.22361 20 4.49976 20H19.4998C19.7759 20 19.9998 19.7761 19.9998 19.5C19.9998 19.2239 19.7759 19 19.4998 19H4.49976Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchlist);

var WatchlistSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { WatchlistSolid as default };
